import { diagsReducer } from './diags/store/reducers'
import { searchReducer, SearchAction } from './nav/store/reducers'
import { authReducer } from './auth/store/reducers'
import { subscriptionsReducer, filtersReducer, FiltersAction, SubscriptionsAction } from '../modules/subscriptions/store/reducers'
import { AppState } from './store'
import { DiagsAction } from './diags/store/reducers'
import { reportsReducer, ReportsAction } from '../modules/reports/store/reducers'
import { dashboardReducer } from '../modules/dashboard/store/reducers'
import { DashboardAction } from '../modules/dashboard/store/reducers'
import { DiagsState } from './diags/store/store'
import { SubscriptionState, FiltersState } from '../modules/subscriptions/store/store'
import { AuthAction } from './auth/store/reducers'
import { AuthState } from './auth/store/store'
import { AccountsAction, accountsReducer } from '../modules/accounts/store/reducers'
import { AccountsState } from '../modules/accounts/store/store'
import { PartnerAction, partnerReducer } from './partner/store/reducers'
import { SettingsAction, settingsReducer } from '../modules/settings/_root/store/reducers'
import { SettingsState } from '../modules/settings/_root/store/store'

export type Action =
  | AuthAction
  | DiagsAction
  | FiltersAction
  | SubscriptionsAction
  | AccountsAction
  | ReportsAction
  | DashboardAction
  | SearchAction
  | PartnerAction
  | SettingsAction

export type State =
  | AuthState
  | DiagsState
  | SubscriptionState
  | AccountsState
  | FiltersState
  | SettingsState


// replace with proper type when we fix context
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ErrorAction = any

function rootReducer(state: AppState, action: Action) {
  const newState = {
    auth: authReducer(state.auth, action as AuthAction),
    search: searchReducer(state.search, action as SearchAction),
    diags: diagsReducer(state.diags, action as DiagsAction),
    dashboard: dashboardReducer(state.dashboard, action as DashboardAction),
    subscriptions: subscriptionsReducer(state.subscriptions, action as SubscriptionsAction),
    accounts: accountsReducer(state.accounts, action as AccountsAction),
    filters: filtersReducer(state.filters, action as FiltersAction),
    reports: reportsReducer(state.reports, action as ReportsAction),
    partner: partnerReducer(state.partner, action as PartnerAction),
    settings: settingsReducer(state.settings, action as SettingsAction)
  }

  // if (process.env.REACT_APP_LOG_STORE_ACTIONS) {
  //   console.log(action.type, {
  //     action,
  //     state,
  //     newState
  //   })
  // }

  return newState
}

export default rootReducer
